import React, {useEffect, useState} from 'react'
import { setActivePage, setActiveChildPage } from '../../../redux/actions/active-page'
import SearchContentField from '../../universal/search-content-field/search-content-field.component'
import DashboardLibraryTable from './table'
import DashboardLibraryUploadModal from './modals/upload-modal'
import DashboardLibraryUnlockModal from './modals/unlock-modal'
import DashboardLibrarySettingsModal from './modals/settings-modal'
import DashboardLibraryDeleteModal from './modals/delete-modal'
import EmptyTableView from '../../universal/empty-table'
import { TableLoader } from '../../library/table-loader'
import { useDispatch, useSelector } from 'react-redux';
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import { resetFileDeletion, resetFileUpload, retrieveLibraryFiles, resetActiveFileSettings, resetSettingsAddPassword, resetSettingsRemovePassword, resetDeleteFileArray, changeLibraryModal, requestDeleteFileArray } from '../../../redux/actions/library'
import { ToastContainer } from 'react-toastify'
import { UpperRow } from '../../library/upper-row'
import { SolidButton } from '../../library/button'
import './style.scss';

const Index = () => {

	const dispatch = useDispatch()
	const library = useSelector(state => state && state.library && state.library)
	const modal = useSelector(state => state.library.showModals)

	const uploadError = useSelector(state => state.library.uploadFile.error)
	const uploadStatus = useSelector(state => state.library.uploadFile.status)

	const deleteError = useSelector(state => state.library.deleteFile.error)
	const deleteStatus = useSelector(state => state.library.deleteFile.status)

	const setPasswordError = useSelector(state => state.library.setFilePassword.error)
	const setPasswordStatus = useSelector(state => state.library.setFilePassword.status)

	const removePasswordError = useSelector(state => state.library.removeFilePassword.error)
	const removePasswordStatus = useSelector(state => state.library.removeFilePassword.status)

	const user = useSelector(state => state && state.auth && state.auth.user && state.auth.user.id)
	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
	
	const deleteArrayError = useSelector(state => state.library.deleteArray.error)
    const deleteArrayStatus = useSelector(state => state.library.deleteArray.status)

	const deleteLoading = useSelector(state => state.library.deleteArray.loading)
    const deletions = useSelector(state => state.library.deletionArray)

	const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)

	const [searchQuery, setSearchQuery] = useState("");

	useEffect(() => {
		dispatch(setActivePage("library"))
		dispatch(setActiveChildPage(null))
	})
	
    const searchLibrary = e => {
        setSearchQuery(e.target.value)
	}

	useEffect(() => {
		dispatch(resetDeleteFileArray())
		dispatch(resetFileUpload())
		dispatch(resetFileDeletion())
		dispatch(resetSettingsAddPassword())
		dispatch(resetActiveFileSettings())
		dispatch(resetSettingsRemovePassword())
	}, [])

	useEffect(() => {
		if(deleteArrayError){
			sendErrorNotification("Kunne ikke slette valgte filer.")
			dispatch(resetDeleteFileArray())
			dispatch(retrieveLibraryFiles({company: selectedCompany, user: user}))
		}
	
		if(deleteArrayStatus){
			sendSuccessNotification("Valgte filer ble slettet.")
			dispatch(resetDeleteFileArray())
			dispatch(retrieveLibraryFiles({company: selectedCompany, user: user}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleteArrayStatus, deleteArrayError])

	useEffect(() => {
		if(uploadStatus){
			sendSuccessNotification("Filen ble lastet opp.")
			dispatch(resetFileUpload())
			dispatch(retrieveLibraryFiles({company: selectedCompany, user: user}))
		}
		if(uploadError){
			sendErrorNotification(uploadError)
			dispatch(resetFileUpload())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uploadStatus, uploadError])

	useEffect(() => {
		if(deleteStatus){
			sendSuccessNotification("Filen ble slettet.")
			dispatch(resetFileDeletion())
			dispatch(retrieveLibraryFiles({company: selectedCompany, user: user}))
		}
		if(deleteError){
			sendErrorNotification(deleteError)
			dispatch(resetFileDeletion())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleteStatus, deleteError])

	useEffect(() => {
		if(setPasswordStatus){
			sendSuccessNotification("Filen ble oppdatert.")
			dispatch(resetSettingsAddPassword())
			dispatch(resetActiveFileSettings())
			dispatch(retrieveLibraryFiles({company: selectedCompany, user: user}))
		}
		if(setPasswordError){
			sendErrorNotification(setPasswordError)
			dispatch(resetSettingsAddPassword())
			dispatch(resetActiveFileSettings())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [setPasswordStatus, setPasswordError])

	useEffect(() => {
		if(removePasswordError){
			sendErrorNotification(removePasswordError)
			dispatch(resetActiveFileSettings())
			dispatch(resetSettingsRemovePassword())
		}
		if(removePasswordStatus){
			sendSuccessNotification("Filen ble oppdatert.")
			dispatch(resetActiveFileSettings())
			dispatch(resetSettingsRemovePassword())
			dispatch(retrieveLibraryFiles({company: selectedCompany, user: user}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [removePasswordStatus, removePasswordError])

	const renderMainButtons = () => {
		return [
			<SolidButton onClick={() => determineDeleteButtonClick()}  color="gray" spacing="right" icon={deleteLoading ? <i className="fas fa-circle-notch fa-spin"/>:<i className="fas fa-trash-alt"/>} title={deleteLoading ? "Sletter..":"Slett filer"}/>,
        	<SolidButton icon={<i class="fad fa-plus"></i>} title="Last opp" color="blue" onClick={() => determineAddButtonClick()} className={determineAddButtonDisplay()}/>
		]
	}

	const clickUploadNewFile = () => {
        if(activeCompany && activeCompany.subscription){
            dispatch(changeLibraryModal({uploadModal: true}))
        }
    }

    const determineAddButtonDisplay = () => {
        if(!activeCompany){
            return "add-file-button disabled"
        }

        if(activeCompany && !activeCompany.subscription){
            return "add-file-button disabled"
        }

        return "add-file-button"
    }

    const determineDeleteButtonClick = () => {
        if(deletions && deletions.length > 0){
            clickDeleteFiles()
        }
    }

    const determineAddButtonClick= () => {
        if(activeCompany && activeCompany.subscription){
            clickUploadNewFile()
        } 
    }

    const clickDeleteFiles = () => {
        dispatch(requestDeleteFileArray({companyId: activeCompany.id, items: deletions}))
    }

    return(
		<section className="dashboard-library-section">
			<div className="inner-dashboard-library-container">
				<UpperRow title="Bibliotek" buttons={renderMainButtons()}/>
				<SearchContentField searchQuery={searchQuery} handleSearch={searchLibrary}/>
				<DashboardLibraryTable searchQuery={searchQuery}/>
				{library.fetchAllFiles.loading ? <TableLoader/>:null}
				{!library.fetchAllFiles.loading && library.content.length === 0 ? <EmptyTableView title="Ingen filer lagt til" description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til en ny fil ved å trykke på knappen øverst til høyre."/>:null}
				{modal.uploadModal ? <DashboardLibraryUploadModal/>:null}
				{modal.unlockModal ? <DashboardLibraryUnlockModal/>:null}
				{modal.settingsModal ? <DashboardLibrarySettingsModal/>:null}
				{modal.deleteModal ? <DashboardLibraryDeleteModal/>:null}
			</div>
			<ToastContainer/>
		</section>
    )
}

export default Index